
const CareCommentIdType = Symbol();

export class CareCommentId {
    [CareCommentIdType]: any;
    readonly value: string;

    private constructor(careCommentId: string) {
        this.value = careCommentId;
    }

    static fromString(careCommentId: string): CareCommentId {
        return new CareCommentId(careCommentId);
    }
}
